/* 🤖 this file was generated by svg-to-ts */
export const mgcIconNotebookFilled: {
  name: 'notebook-filled';
  data: string;
} = {
  name: 'notebook-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.58 2.047c-.733.14-1.4.821-1.537 1.57-.061.334-.061 16.432 0 16.766.141.768.806 1.433 1.574 1.574.133.024.713.043 1.31.043H8V2l-1.11.004c-.61.003-1.2.022-1.31.043M10 11.999V22h3.616c4.09 0 4.007.005 4.644-.296a2.925 2.925 0 0 0 1.444-1.444c.315-.666.296-.137.296-8.26s.019-7.594-.296-8.26a2.94 2.94 0 0 0-1.408-1.428c-.64-.308-.325-.287-4.526-.302L10 1.997z"/></svg>`
};
